module.exports = __webpack_public_path__ + "img/img_guwen@2x.f2559e66.png";